export const PUSH_ALERT = 'PUSH_ALERT';
export const POP_ALERT = 'POP_ALERT';
export const POP_ALL_ALERTS = 'POP_ALL_ALERTS';

export function pushAlert({
  level,
  title,
  subtitle,
  target,
  icon,
  closeIcon,
  hideClose,
  onClick,
  onClose,
}) {
  return {
    type: PUSH_ALERT,
    level,
    title,
    subtitle,
    target,
    icon,
    closeIcon,
    hideClose,
    onClick,
    onClose,
  };
}

export function popAlert() {
  return {type: POP_ALERT};
}

export function popAllAlerts() {
  return {type: POP_ALL_ALERTS};
}



// WEBPACK FOOTER //
// ./src/ondemand/actions/alert.js